// ThisVue
export default {
	vue: null,

	init(vue) {
		this.vue = vue
	}
}